import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'

//详情
export interface IDriverDetail {
    id?: string
    prefix?: string
    shopId?: string
    shopCode?: string
    shopName?: string
    branch?: string
    ver?: string
    enable?: string
    orgCode?: string
    orgName?: string
    contact?: string
    phone?: string
    address?: string
    status?: number | boolean
    sourceApp?: string
    categoryName?: string
    typeCode?: string
    typeName?: string
    suffixNum?: number
    settingType?: string
    isYear?: number
    isMonth?: number
    isDate?: number
    style?: string
    note?: string
    orderNum?: number
    traceId?: string
    deleteFlag?: number
    createTime?: string
    updateTime?: string
    createUser?: string
    updateUser?: string
    [key: string]: any
}

//搜索条件
export interface IDriverSearchFields {
    startTime?: string
    endTime?: string
    [key: string]: any
}

export interface IDriverSearch extends IDriverSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

class Service {
    async page(searchVo: IDriverSearch, config: object = {}) {
        const apiUrl = '/threeInspection/base/driver/list'
        return await httpRequest.post<IPage<IDriverDetail>>(apiUrl, searchVo, config)
    }
    async insert(searchVo: IDriverSearchFields) {
        const apiUrl = '/threeInspection/base/driver/insert'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async edit(searchVo: IDriverSearchFields) {
        const apiUrl = '/threeInspection/base/driver/update'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async onDelete(searchVo: IDriverSearchFields) {
        const apiUrl = '/threeInspection/base/driver/delete'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
}

export const service = new Service()
